import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { ApproveAreaSuggestionResult } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import {
  invalidateAdminAreas,
  invalidateAdminAreaSuggestions,
} from "@/lib/query/core/invalidation";

type ApproveAreaSuggestionInput = {
  id: string;
  nameAr: string;
  nameEn?: string;
};

export function useApproveAreaSuggestionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, ...body }: ApproveAreaSuggestionInput) =>
      apiJsonClient<ApproveAreaSuggestionResult>(
        endpoints.admin.areaSuggestionApprove(id),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async () => {
      await Promise.all([
        invalidateAdminAreaSuggestions(queryClient),
        invalidateAdminAreas(queryClient),
      ]);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
